import { Component, Input, OnInit } from '@angular/core';
import { ServerMessage } from '../../../models/server-message';
import { LocaleService } from '../services/locale.service';
import { IconEnum } from '../../../enum/icon.enum';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'app-server-message',
    templateUrl: './server-message.component.html',
    styleUrls: ['./server-message.component.scss'],
    imports: [IconComponent]
})
export class ServerMessageComponent implements OnInit {

    @Input()
    public message: ServerMessage;

    constructor(private localeService: LocaleService) {
    }

    ngOnInit(): void {
    }

    icon(): IconEnum {
        return this.message.type === 'NOTICE' ? 'notice' : 'warning';
    }

    warning(): boolean {
        return this.message.type === 'ERROR';
    }

    displayText(): string {
        return this.localeService.renderServerMessage(this.message);
    }

}
